import { useEffect, useMemo, useState, useRef } from 'react'
import * as XLSX from 'xlsx';
import { useForm } from 'react-hook-form'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import FolderUploadLineIcon from 'remixicon-react/FolderUploadLineIcon';
import FileSaver from 'file-saver';
import { useDispatch, useSelector } from 'react-redux';
import Papa from 'papaparse'
import Button from '../../components/utils/Button'
import SearchBar from '../../components/utils/SearchBar'
import PlanWiseMappingActions from '../../redux/planWiseMapping/actions';
import dealerAction from '../../redux/dealer/actions'
import Table from '../../components/utils/Table'
import Alert from '../../components/utils/Alert';
import SideButtons from '../../components/utils/SideButtons'
import { useNavigate } from "react-router-dom";
import networkActions from '../../redux/network/actions'
import { Link } from 'react-router-dom';
import PencilFill from 'remixicon-react/PencilFillIcon';
import PriceMappingModel from '../../components/utils/PriceMappingModel';

const { getPlanWiseMappingForDPM, getAllPlanPriceMappingDataForDPM, updateDealerPlanMappingforDPM, resetPlanPriceMappingMessages, closeUpdatePortinModal, openUpdatePortinModal, updateDealerPlanMappingforDPMByDealerId } = PlanWiseMappingActions;
const { getDealer } = dealerAction;

const { getNetworkForDPMMultiPlan } = networkActions;

export const DailyPlanMultiPlanMapping = () => {
    const dispatch = useDispatch();
    const [uploadPlanPriceMapping, setUploadPlanPriceMapping] = useState(false);
    const { planWiseMappingList, planWiseMappingListDPM, PlanPriceMappingDataDPM, buttonLoading, loading, dailyPlanMappingDPMError, dailyPlanMappingDPMSuccess, openPortinModal, dailyPlanMappingDPMByDealerIDMessage, dailyPlanMappingDPMByDealerIDError, dailyPlanMappingDPMByDealerIDLoading } = useSelector((state) => state.planWiseMapping);
    const { networkDPMData } = useSelector((state) => state.network);
    const { dealerResult } = useSelector((state) => state.dealer);
    const [previewSubmitBtn, setPreviewSubmitBtn] = useState(true);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const navigate = useNavigate();
    const initialForm = {
        networkID: 1,
    }
    useEffect(() => {
        dispatch(getPlanWiseMappingForDPM())
        dispatch(getDealer());
        dispatch(getNetworkForDPMMultiPlan());
    }, []);

    useEffect(() => {
        if (dailyPlanMappingDPMError !== null && dailyPlanMappingDPMError !== undefined) {
            displayAlert(dailyPlanMappingDPMError, 'alert-danger');
        }
        if (dailyPlanMappingDPMSuccess !== null && dailyPlanMappingDPMSuccess !== undefined) {
            displayAlert(dailyPlanMappingDPMSuccess, 'alert-success');
        }
        if (dailyPlanMappingDPMByDealerIDError !== null && dailyPlanMappingDPMByDealerIDError !== undefined) {
            displayAlert(dailyPlanMappingDPMByDealerIDError, 'alert-danger');
        }
        if (dailyPlanMappingDPMByDealerIDMessage !== null && dailyPlanMappingDPMByDealerIDMessage !== undefined) {
            displayAlert(dailyPlanMappingDPMByDealerIDMessage, 'alert-success');
            resetPlanPriceMapping();
        }

    }, [dailyPlanMappingDPMError, dailyPlanMappingDPMSuccess, dailyPlanMappingDPMByDealerIDMessage, dailyPlanMappingDPMByDealerIDError]);

    useEffect(() => {
        if (dailyPlanMappingDPMSuccess) {
            setUploadPlanPriceMapping(false);
        }
    }, [dailyPlanMappingDPMSuccess]);

    /**************** for plan price mapping search  *************************/
    const {
        register: registerPlanPriceMapping,
        handleSubmit: handleSubmitPlanPriceMapping,
        watch: watchPlanPriceMapping,
        formState: {
            errors: errorsPlanPriceMapping
        },
        reset: resetPlanPriceMapping,
        getValues: getValuesPlanMapping
    } = useForm({
        defaultValues: initialForm

    });
    let seachedNetworkId = watchPlanPriceMapping('networkID');

    /**************** end for plan price mapping search  *************************/

    const { register, handleSubmit, watch, formState: { errors }, setValue, setError: uploadSetError, clearErrors, reset, getValues } = useForm({
        defaultValues: {
            networkID: '1',
        }
    });

    const addSectionNetworkID = watch('networkID');

    useEffect(() => {
        if (addSectionNetworkID) {
            let req = {
                networkID: addSectionNetworkID,
            }
            dispatch(getAllPlanPriceMappingDataForDPM(req));

        }
    }, [addSectionNetworkID]);

    useEffect(() => {
        if (networkDPMData && networkDPMData.length > 0) {
            const firstNetwork = networkDPMData.find(n => n.IsActive == 1);
            if (firstNetwork) {
                resetPlanPriceMapping({
                    networkID: firstNetwork.ID
                });
            }
        }
    }, [networkDPMData]);

    useEffect(() => {
        if (networkDPMData && networkDPMData.length > 0) {
            const firstNetwork = networkDPMData.find(n => n.IsActive == 1);
            if (firstNetwork) {
                reset({
                    networkID: firstNetwork.ID
                });
            }
        }
    }, [networkDPMData]);

    useEffect(() => {
        if (networkDPMData && networkDPMData.length > 0) {
            const firstNetwork = networkDPMData.find(n => n.IsActive == 1);

            if (firstNetwork) {
                dispatch(getAllPlanPriceMappingDataForDPM({
                    networkID: firstNetwork.ID
                }));
            }
        }
    }, [networkDPMData]);

    const [filterText, setFilterText] = useState("");
    const [uploadedMapping, setUploadedMapping] = useState([]);
    const [previewHeading, setPreviewHeading] = useState([]);
    const [previewDataSourceExcel, setPreviewDataSourceExcel] = useState([]);
    const [priceMappingData, setPriceMappingData] = useState([]);
    const [dealerID, setDealerID] = useState(null);
    const [dealerName, setDealerName] = useState(null);
    const fileInputRef = useRef(null);

    // TABLE HEADING
    const networkData = useMemo(() => {
        if (planWiseMappingListDPM && planWiseMappingListDPM.length > 0) {
            if (!uploadPlanPriceMapping) {
                return planWiseMappingListDPM.filter(item => item.ID == seachedNetworkId).map((item) => {
                    let planData = JSON.parse(item.PlanData);
                    let networkName = item.NetworkName;
                    let newArr = planData.map((plan) => {
                        // let newArr = planData.filter((item) => item.MultilineFlag == 1).map((plan) => {
                        return `${plan.PlanName}|$${plan.PlanPrice}|${networkName}`;
                    });
                    return newArr;
                })
            } else {
                return planWiseMappingListDPM.filter(item => item.ID == addSectionNetworkID).map((item) => {
                    let planData = JSON.parse(item.PlanData);
                    let networkName = item.NetworkName;
                    let newArr = planData.filter((item) => item.MultilineFlag == 1).map((plan) => {
                        return `${plan.PlanName}|$${plan.PlanPrice}|${networkName}`;
                    });
                    return newArr;
                })
            }
        } else {
            return [];
        }
    }, [planWiseMappingListDPM, addSectionNetworkID, PlanPriceMappingDataDPM, seachedNetworkId, uploadPlanPriceMapping]);

    const newHeadingData = useMemo(() => {
        if (networkData && networkData.length > 0) {
            return networkData.flat().map(item => ({
                displayName: item,
                key: item
            }));
        } else {
            return [];
        }
    }, [networkData]);

    const heading = [
        { displayName: '#', key: 'key' },
        { displayName: 'Dealer', key: 'dealerName' },
        ...(newHeadingData || []),
        { displayName: 'Action', key: 'action' },

    ];
    // END TABLE HEADING

    // TABLE DATASOUCE
    const newDataSource = useMemo(() => {
        if (PlanPriceMappingDataDPM && PlanPriceMappingDataDPM.length > 0) {
            return Object.values(PlanPriceMappingDataDPM && PlanPriceMappingDataDPM.length > 0 && PlanPriceMappingDataDPM.filter((item) => item.PlanPrice != null && item.PlanPrice != undefined).reduce((acc, item) => {
                const { DealerID, DealerName, DealerPrice, NetworkName, PlanName, PlanPrice } = item;
                const plannewHeading = `${PlanName}|$${PlanPrice}|${NetworkName}`
                if (!acc[DealerID]) {
                    acc[DealerID] = { DealerID, DealerName };
                }
                acc[DealerID][plannewHeading] = DealerPrice;
                return acc;
            }, {}));
        } else {
            return [];
        }
    }, [PlanPriceMappingDataDPM]);

    const Keys = newDataSource && newDataSource.length > 0 && Object.keys(newDataSource[0]);

    const filteredItems = Array.isArray(newDataSource) && newDataSource.length > 0 ? newDataSource.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        // Check if any value in the object contains the filterText
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    const DataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((plan, index) => {
        const obj = {
            key: index + 1,
            dealerName: plan.DealerName,
            childPrice: plan.childPrice !== '' && plan.childPrice !== null && plan.childPrice !== undefined ? plan.childPrice : '$0'
        };

        Keys.forEach(key => {
            obj[key] = plan[key] ? `$${plan[key]}` : '$0';
        });
        if (newHeadingData && newHeadingData.length > 0) {
            obj.action = (
                <Link to="#">
                    <span data-toggle="tooltip" data-placement="top" title="Edit">
                        <PencilFill size="1.4em" style={{ color: "#888b8e", marginRight: "3px", cursor: "pointer" }}
                            onClick={() => handleclickModel(plan)} />
                    </span>
                </Link>
            );
        }
        return obj;
    });
    // END TABLE DATASOUCE

    const handleclickModel = (data) => {
        setDealerID(data.DealerID)
        setDealerName(data.DealerName)
        const newArrayData = PlanPriceMappingDataDPM && PlanPriceMappingDataDPM.length > 0 && PlanPriceMappingDataDPM.filter(item => item.DealerID == data.DealerID);
        const result = networkDPMData.flatMap(item1 => {
            const networkInfo = planWiseMappingListDPM.find(n => n.ID === item1.ID);
            let parsedPlans = [];

            if (networkInfo) {
                try {
                    parsedPlans = JSON.parse(networkInfo.PlanData);
                } catch (err) {
                    console.error('Error parsing PlanData for', item1.NetworkName, err);
                }
            }

            const dealerEntries = newArrayData.filter(d => d.NetworkID === item1.ID);
            return dealerEntries.map(d => {
                const plan = parsedPlans.find(p => p.ID === d.PlanID) || {};
                if (!plan.ID) {
                    return null;
                }
                const name = plan.PlanName || '';
                const price = plan.PlanPrice != null ? plan.PlanPrice : '';
                const label = `${name} | $${price} | ${item1.NetworkName}`;
                return {
                    networkID: item1.ID,
                    dealerPrice: d.DealerPrice ?? 0,
                    networkName: label
                };
            }).filter(item => item !== null);
        });
        setPriceMappingData(result);
        dispatch(openUpdatePortinModal());
    };


    const handleCloseModal = () => {
        dispatch(closeUpdatePortinModal())
    };

    const handleUpdate = (data) => {
        const filteredPlans = PlanPriceMappingDataDPM.filter(item => item.NetworkID !== null && item.DealerID == dealerID);
        const updateData = data.prices.filter((_, ind) => filteredPlans[ind]).map((item, ind) => ({
            ...item,
            dealerPrice: item.dealerPrice === "" ? 0 : item.dealerPrice,
            planId: filteredPlans[ind].PlanID,
            networkId: filteredPlans[ind].NetworkID
        }));
        const searchData = {
            networkID: getValues('networkID'),
        };
        dispatch(updateDealerPlanMappingforDPMByDealerId(dealerID, updateData, searchData));
    };

    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const uploadView = () => {
        setUploadPlanPriceMapping(true);
    }

    const closeUploadView = () => {
        setUploadPlanPriceMapping(false);
        setPreviewSubmitBtn(true)
        setPreviewHeading([])
        reset()
    }

    const dealerData = dealerResult && dealerResult.length > 0 && dealerResult.filter((item) => item.ParentID == 1).map((item) => {
        return {
            name: item.DealerName,
            dealerId: item.ID
        }
    });

    const exportToCSV = async () => {
        const selectedNetworkId = watchPlanPriceMapping('networkID');
        const filteredData = PlanPriceMappingDataDPM.filter(
            item => item.NetworkID == selectedNetworkId
        );
        const transformedData = {};
        filteredData.forEach(item => {
            if (!transformedData[item.DealerName]) {
                transformedData[item.DealerName] = {
                    name: item.DealerName,
                    dealerId: item.DealerID,
                    ChildPrice: item.ChildPrice
                };
            }
            transformedData[item.DealerName][`${item.PlanName}|$${item.PlanPrice}|${item.NetworkName}`] = item.ChildPrice;
        });

        const resultArray = Object.values(transformedData);

        const selectedNetwork = planWiseMappingListDPM.find(item => item.ID == selectedNetworkId);

        // const topRowNetworks = networkData.flat(1);

        let topRowNetworks = [];

        if (selectedNetwork) {
            const parsedPlans = JSON.parse(selectedNetwork.PlanData);

            topRowNetworks = parsedPlans.map(plan =>
                `${plan.PlanName}|$${plan.PlanPrice}|${selectedNetwork.NetworkName}`
            );
        }

        const wb = XLSX.utils.book_new();
        // const ws = XLSX.utils.aoa_to_sheet([['Dealer Name', 'Dealer ID', 'Month', 'Child Price', ...networkData.flat(1)]]);
        // const ws = XLSX.utils.aoa_to_sheet([['Dealer Name', 'Dealer ID', 'Month', ...networkData.flat(1)]]);
        // const ws = XLSX.utils.aoa_to_sheet([['Dealer Name', 'Dealer ID', ...networkData.flat(1)]]);
        const ws = XLSX.utils.aoa_to_sheet([['Dealer Name', 'Dealer ID', ...topRowNetworks]]);
        let dealerColIndex = 1;
        // let rowIndex = 1;


        if (resultArray && resultArray.length > 0) {
            resultArray && resultArray.length > 0 && resultArray.forEach((planData) => {
                let newRow = [];
                const keys = Object.keys(planData);
                const dealerRow = keys.map(key => planData[key]);
                newRow.push(dealerRow[0]);
                newRow.push(dealerRow[1]);
                // newRow.push(dealerRow[2] != '' && dealerRow[2] != null && dealerRow[2] != undefined ? dealerRow[2] : '0');

                topRowNetworks.forEach((item) => {
                    if (planData[item]) {
                        newRow.push(planData[item]);
                    } else {
                        newRow.push(0);
                    }
                });

                XLSX.utils.sheet_add_aoa(ws, [newRow], { origin: { r: dealerColIndex, c: 0 } });
                dealerColIndex += 1;
            })
        } else {
            dealerData.forEach((dealer) => {
                const dealerRow = [dealer.name, dealer.dealerId];
                XLSX.utils.sheet_add_aoa(ws, [dealerRow], { origin: { r: dealerColIndex, c: 0 } });
                dealerColIndex += 1;
            });

        }

        XLSX.utils.book_append_sheet(wb, ws, 'Plan Price Mapping');
        const excelBuffer = XLSX.write(wb, { bookType: 'csv', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let fileName = `existing-dealer-daily-plan-mapping-multi-plan`;
        FileSaver.saveAs(data, `${fileName}.csv`);
    }

    const handleFileChange = (e) => {
        const fileReader = new FileReader();
        let file = e.target.files[0];
        let uploadedData = [];

        setPreviewDataSourceExcel([]);
        setPreviewHeading([]);

        if (file) {
            const fileName = file.name;
            const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

            if (fileExtension !== "csv") {
                uploadSetError("uploadedFile", { type: "custom", message: "Invalid file type. Only CSV file allowed." });
                return;
            }
            clearErrors("uploadedFile");
            fileReader.onload = async ({ target }) => {
                const csvOutput = Papa.parse(target.result, { header: true });
                const parsedData = csvOutput?.data;
                if (!parsedData || parsedData.length === 0) {
                    uploadSetError("uploadedFile", { type: "custom", message: "Empty or invalid CSV file." });
                    return;
                }
                const matchedNetwork = planWiseMappingListDPM.find(item => item.ID == addSectionNetworkID);
                if (!matchedNetwork) {
                    uploadSetError("uploadedFile", { type: "custom", message: "Selected network data not found." });
                    return;
                }
                const csvHeaders = Object.keys(parsedData[0]);
                const networkNameInCSV = csvHeaders.find(header => {
                    const parts = header.split("|");
                    return parts.length === 3 && parts[2] === matchedNetwork.NetworkName;
                });
                if (!networkNameInCSV) {
                    uploadSetError("uploadedFile", { type: "custom", message: "Uploaded file network does not match the selected network." });
                    return;
                }
                const customizeData = [];
                const parsedPlanData = JSON.parse(matchedNetwork.PlanData);
                // parsedPlanData
                //     .filter(item => item.MultilineFlag == 1)
                parsedPlanData
                    .forEach((item1) => {
                        customizeData.push({
                            column: `${item1.PlanName}|$${item1.PlanPrice}|${matchedNetwork.NetworkName}`,
                            planId: item1.ID
                        });
                    });
                dealerData.forEach((dealer) => {
                    customizeData.forEach((item) => {
                        let row = parsedData.find(item1 => item1['Dealer ID'] == dealer.dealerId);
                        if (row) {
                            uploadedData.push({
                                dealerId: dealer.dealerId,
                                dealerName: dealer.name,
                                planId: item.planId,
                                planHeading: item.column,
                                dealerPrice: row[item.column],
                                childPrice: row['Child Price'],
                            });
                        } else {
                            console.error(`No data found for dealer with ID ${dealer.dealerId}`);
                        }
                    });
                });
                const uniquePlanIds = [...new Set(uploadedData.map(item => item.planHeading))];
                const heading = [
                    { displayName: '#', key: 'key' },
                    { displayName: 'Dealer', key: 'dealerName' },
                    ...uniquePlanIds.map(id => ({ displayName: `${id}`, key: `${id}` }))
                ];
                setPreviewHeading(heading);
                const groupedData = uploadedData.reduce((acc, item) => {
                    const { dealerId, dealerName, planHeading, dealerPrice } = item;
                    if (!acc[dealerId]) {
                        acc[dealerId] = { dealerId, dealerName };
                    }
                    // acc[dealerId][planHeading] = `$${dealerPrice}` || `$0`;
                    acc[dealerId][planHeading] = dealerPrice !== undefined && dealerPrice !== null && dealerPrice !== "" ? `$${dealerPrice}` : `$0`;
                    return acc;
                }, {});

                setPreviewDataSourceExcel(Object.values(groupedData));
                setUploadedMapping(uploadedData);
                setPreviewSubmitBtn(false);
            };
            fileReader.readAsText(file);
        }
    };


    // PREVIEW TABLE HEADING
    const previewColumns = previewHeading

    // END PREVIEW TABLE HEADING


    const PreviewKeys = previewDataSourceExcel && previewDataSourceExcel.length > 0 && Object.keys(previewDataSourceExcel[0]);

    const previewDataSource = previewDataSourceExcel && previewDataSourceExcel.length > 0 && previewDataSourceExcel.map((plan, index) => {
        const obj = {
            key: index + 1,
            childPrice: `$${plan.childPrice}`
        };
        PreviewKeys.forEach(key => {
            if (key != 'childPrice') {
                obj[key] = plan[key];
            }
        });
        return obj;
    });

    const onSubmit = (data) => {
        let UpdateDataArray = [];
        let insertedArray = [];
        // let selectedMonth = getValues('month');

        uploadedMapping.forEach((firstItem) => {
            // if (parseFloat(firstItem.dealerPrice) > 0) {
            // }
            firstItem.dealerPrice = firstItem.dealerPrice >= 0 ? parseFloat(firstItem.dealerPrice) : 0;
            let matchFound = false;
            PlanPriceMappingDataDPM.forEach((secondItem) => {
                // if (firstItem.dealerId === secondItem.DealerID && firstItem.planId === secondItem.PlanID && secondItem.DealerMonth == selectedMonth) {
                if (firstItem.dealerId === secondItem.DealerID && firstItem.planId === secondItem.PlanID) {
                    matchFound = true;
                    UpdateDataArray.push(firstItem);
                }
            });
            if (!matchFound) {
                insertedArray.push(firstItem);
            }
        });

        const { networkID } = getValuesPlanMapping();

        // const finalData = {
        //     insertData: insertedArray,
        //     updateData: UpdateDataArray,
        // };
        const finalData = {
            insertData: insertedArray.map(item => ({ ...item, networkId: networkID })),
            updateData: UpdateDataArray.map(item => ({ ...item, networkId: networkID })),
        };
        let sData = getValuesPlanMapping();
        // console.log("finalData", finalData)
        dispatch(updateDealerPlanMappingforDPM(finalData, sData));
        reset();
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        setUploadPlanPriceMapping(false);
        setPreviewSubmitBtn(true)
        setPreviewHeading([])
        dispatch(resetPlanPriceMappingMessages());
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetPlanPriceMappingMessages());
    }

    const handleSideButton = () => {
        if (networkDPMData.length <= 0) {
            navigate("/network");
        } else if (dealerResult.length <= 0) {
            navigate("/dealer");
        }
    }


    const handlePlanPriceMappingSearch = (data) => {
        // dispatch(getAllPlanPriceMappingData(data));
        dispatch(getAllPlanPriceMappingDataForDPM(data));
    }

    return (
        <>
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            {
                !uploadPlanPriceMapping ? <>
                    <div className='row align-items-center mb-4'>

                        <div className='col-md-12 mb-3'>
                            <form onSubmit={handleSubmitPlanPriceMapping(handlePlanPriceMappingSearch)}>
                                <div className="form-row">

                                    <div className="col-lg-3">
                                        <label>Select Network</label>
                                        <select className="form-control" id="networkID" name="networkID" {...registerPlanPriceMapping("networkID", {
                                        })} >
                                            {
                                                networkDPMData && networkDPMData.length > 0 && networkDPMData.filter((item) => item.IsActive == 1).map((item, index) => {
                                                    return <option value={item.ID}>{item.NetworkName}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className={`col-lg-2 mt-3`}>
                                        <div className={`mt-2 d-flex justify-content-end`}>
                                            <Button title="Search" style="minWidth:80px" loading={loading} buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>

                        <div className="col-md-6 od-2">
                            <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                        </div>
                        <div className="col-md-6  text-right">
                            {
                                networkDPMData.length <= 0 ?
                                    <SideButtons title="Add Network" buttonStyle="primary" onClick={handleSideButton} /> :
                                    dealerResult.length <= 0 ?
                                        <SideButtons title="Add Dealer" buttonStyle="primary" onClick={handleSideButton} /> :
                                        <Button icon={<FolderUploadLineIcon color='#fff' className='mr-1' size={'0.9rem'} />} title='Upload' buttonClass="btn btn-primary float-right ml-2" onClick={uploadView} loading={false} buttonType='submit' />
                            }
                        </div>
                    </div>

                    <Table data={DataSource} columns={heading} loading={loading} pagination={true} />
                </> :
                    <>
                        <div className='row align-items-center mb-4'>
                            <div className="col-md-12 text-right">
                                <Button icon={<DownloadCloud2sLineIcon color='#fff' className='mr-1' size={'0.9rem'} />} title='Existing Daily Plan Mapping-Multi Plan' buttonClass="btn btn-primary float-right" onClick={exportToCSV} loading={false} buttonType='submit' />
                            </div>
                        </div>

                        <div className="row">
                            <div className='col-md-12'>
                                <form className="form px-4" onSubmit={handleSubmit(onSubmit)}>

                                    <div className="form-row">

                                        <div className="col-lg-3">
                                            <label>Select Network</label>
                                            <select className="form-control" id="networkID" name="networkID" {...register("networkID", {
                                            })}
                                                onChange={(e) => {
                                                    setValue("networkID", e.target.value);
                                                    setPreviewDataSourceExcel([]);
                                                    setPreviewHeading([]);
                                                    clearErrors("uploadedFile");
                                                    if (fileInputRef.current) {
                                                        fileInputRef.current.value = "";
                                                    }
                                                }}
                                            >
                                                {
                                                    networkDPMData && networkDPMData.length > 0 && networkDPMData.filter((item) => item.IsActive == 1).map((item, index) => {
                                                        return <option value={item.ID}>{item.NetworkName}</option>
                                                    })
                                                }
                                            </select>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="input-group">
                                                <label htmlFor="csvFile"><span className='text-danger'>*</span>Upload File </label>
                                                <input
                                                    type="file"
                                                    className="form-control-file"
                                                    name='uploadedFile'
                                                    id="csvFile"
                                                    accept='.csv'
                                                    {...register('uploadedFile', { required: 'Csv is required' })}
                                                    ref={(e) => {
                                                        register("uploadedFile").ref(e);
                                                        fileInputRef.current = e;
                                                    }}
                                                    onChange={(e) => handleFileChange(e)}
                                                />
                                                {errors && errors.uploadedFile && (<div className="invalid-feedback">{errors.uploadedFile.message}</div>)}
                                            </div>
                                        </div>
                                    </div>

                                    {previewHeading && previewHeading.length > 0 && <Table data={previewDataSource} columns={previewColumns} loading={false} pagination={true} />}

                                    <div className='text-right row mt-2'>
                                        <div className="col-md-12">
                                            <button type="button" className="btn btn-secondary mr-2" onClick={closeUploadView}>Close</button>
                                            <Button title="Submit" disable={previewSubmitBtn} style="minWidth:80px" buttonClass="btn btn-primary" loading={buttonLoading} buttonType='submit' />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </>
            }
            <PriceMappingModel showModal={openPortinModal} title={`Update Daily Plan Mapping-Multi Plan:${dealerName}`} handleCancel={handleCloseModal} buttonTitle={"Submit"} submitData={handleUpdate} priceMappingData={priceMappingData} loading={dailyPlanMappingDPMByDealerIDLoading} labelClass="labelplanmp" />
        </>
    )
}
